import commitMutation from 'relay-commit-mutation-promise';
import { graphql, Environment } from 'react-relay';

import {
    profileStatusMutation as MutationType,
    DesignProfileStatusMutationInput,
    profileStatusMutationResponse,
} from './__generated__/profileStatusMutation.graphql';

const mutation = graphql`
    mutation profileStatusMutation($input: DesignProfileStatusMutationInput!) {
        designProfileStatusMutation(input: $input) {
            tradeFirm {
                profileStatus
            }
        }
    }
`;

export const profileStatusMutation = async (
    environment: Environment,
    variables: DesignProfileStatusMutationInput
): Promise<profileStatusMutationResponse> => {
    return await commitMutation<MutationType>(environment, {
        mutation,
        variables: { input: variables },
    });
};
